import utils from "../utils";

////// detect support for Object Fit CSS property and load a fallback if not supported ////////
////// after the detection initialize lazy loader for all images ////////
function initImages() {
	if (!utils.objectFitReady) {
		var objectFitScript = document.createElement("script");
		objectFitScript.src = window.baseUrl + "/js/build/ofi.min.js";
		utils.body.appendChild(objectFitScript);
		objectFitScript.addEventListener("load", function () {
			this.initLazyLoad();
		});
	} else {
		this.initLazyLoad();
	}
}

function initLazyLoad() {
	var imgs = document.querySelectorAll("[data-src]"),
		srcsetReady = "sizes" in document.createElement("img");

	//https://caniuse.com/intersectionobserver

	function initAnimationThumb(elem) {
		if (!srcsetReady || elem.getAttribute("data-srcset") == "") {
			var src = elem.getAttribute("data-src");
			elem.setAttribute("src", src);
			elem.removeAttribute("data-src");
		}
		if (srcsetReady) {
			var srcset = elem.getAttribute("data-srcset");
			elem.setAttribute("srcset", srcset);
			elem.removeAttribute("data-srcset");
		}

		var parent = elem.parentElement,
			thumb = parent.querySelector("img.thumb");

		utils.isImageLoaded(elem, function () {
			parent.parentElement.classList.add("lazy");

			elem.addEventListener("transitionend", function () {
				if (thumb) {
					thumb.style.display = "none";
				}
			});
			elem.addEventListener("transitioncancel", function () {
				if (thumb) {
					thumb.style.display = "none";
				}
			});
		});
	}

	function startObserverLazy() {
		let lazyImageObserver = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						//TODO change
						var lazyImage = entry.target;
						initAnimationThumb(lazyImage);
						lazyImageObserver.unobserve(lazyImage);
					}
				});
			},
			{
				rootMargin: "20% 0px 20% 0px",
				threshold: 0.5,
			}
		);
		utils.forEach(imgs, function (index, elem) {
			//TODO es6
			lazyImageObserver.observe(elem);
		});
	}

	if (imgs.length > 0) {
		startObserverLazy();
		//loadIntersectionScript(startObserverLazy); //TODO caricare script
	}
}

export default {
	initLazyLoad,
	initImages,
};
